import { N as NcActionButton } from "./chunks/NcActionButton-CpGK6gSX.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-BkU5oOmB.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-DSMKeccY.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-D3FN751M.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-yAm71xxU.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-CzpbMJoY.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-a_607PST.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-CP6G4fZX.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-sCuN3OZe.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-B-5VHm-a.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-D7Y5mGGC.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import NcAppNavigationNew from "./Components/NcAppNavigationNew.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-DgTuysCV.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-9NTDoHar.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-CS36ibjM.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-DBViVlqo.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-6PtLRD0F.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-G2VD8Nfl.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-DC7NtEPz.mjs";
import { u } from "./chunks/NcAvatar-DC7NtEPz.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-do2wxY-0.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-WO64bNkF.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-DrTlt5X4.mjs";
import NcButton from "./Components/NcButton.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-BIEYfWtF.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-CdqFiw6Z.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-CtcS-XMk.mjs";
import { N as NcContent } from "./chunks/NcContent-BOBFr3nn.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-CDfRYl8B.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-C3FrsWrR.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-D83T9o2C.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-kanSdMgW.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-OV8kfc5o.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-BhuiKGmE.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-BJSfoews.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import NcHeaderButton from "./Components/NcHeaderButton.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-Dj7jeq88.mjs";
import { N as NcHighlight } from "./chunks/index-Bz6q9mZw.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-Cb-cPj1R.mjs";
import { N as NcInputField } from "./chunks/NcInputField-DTtUueUZ.mjs";
import { N as NcListItem } from "./chunks/NcListItem-BHhlE1Sb.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-BDq6PIUq.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-5oXVlA4T.mjs";
import { N as NcPopover } from "./chunks/NcPopover-kYsewfff.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-DegJ2JjE.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-w0cVgK_u.mjs";
import { N as NcMentionBubble } from "./chunks/index-Dpk-sL3D.mjs";
import { r } from "./chunks/index-Dpk-sL3D.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-Cqt-neS3.mjs";
import { N as NcRichText } from "./chunks/NcRichText-BWY0OxW9.mjs";
import { N, h, d, i, b, r as r2, c, a } from "./chunks/index-56SXuvlv.mjs";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a as a2, g, b as b2, c as c2, d as d2, s } from "./chunks/referencePickerModal-sscttPbK.mjs";
import "unist-util-visit";
import "unist-builder";
import "@nextcloud/router";
import "@nextcloud/axios";
import "@nextcloud/sharing/public";
import "@nextcloud/auth";
import { N as NcSelect } from "./chunks/NcSelect-DmIaznJY.mjs";
import { N as NcTextField } from "./chunks/NcTextField-Cd_RjGj6.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-nv1147dk.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-MsqvY1l4.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-BYynRS17.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-BXbSSC7N.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-BNefU-yk.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-DWEorw2V.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-BHERsE_g.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-BjUmYLVj.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-DH2UiUfH.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-Bya1v9qo.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e, g as g2, s as s2 } from "./chunks/emoji-BY_D0V5K.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { u as u2 } from "./chunks/usernameToColor-BPaEECqs.mjs";
import directive from "./Directives/Focus.mjs";
import { directive as directive$1 } from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a2 as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b2 as getProvider,
  c2 as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  d as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  b as registerCustomPickerElement,
  r2 as registerWidget,
  c as renderCustomPickerElement,
  a as renderWidget,
  r as richEditor,
  d2 as searchProvider,
  s2 as setCurrentSkinTone,
  s as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  u2 as usernameToColor
};
//# sourceMappingURL=index.mjs.map
